export default __webpack_public_path__ + "static/media/WF_DGID_WIP_16x9.c5ce65eb.mp4";